import { createBrowserRouter } from "react-router-dom";
import AppShell from "./layout/AppShell";
import MainDashboard from "./pages/MainDashboard";
import Login from "./pages/Login";

// Importa i componenti unificati
import BatteriesPage from "./pages/Batteries";
import BatteryFirmwaresPage from "./pages/BatteryFirmwares";
import BatteryStationsPage from "./pages/BatteryStations";
import BatterySubscriptionsPage from "./pages/BatterySubscriptions";
import HomeChargersPage from "./pages/HomeChargers";
import HomeChargerSubscriptionsPage from "./pages/HomeChargerSubscriptions";
import VehiclesPages from "./pages/Vehicles";
import UsersPage from "./pages/Users";
import GroupsPage from "./pages/Groups";
import RolesPage from "./pages/Roles";
import AppUsersPage from "./pages/AppUsers";
import AppUsersDetilePage from "./pages/AppUsersDetile";
import MessagesPage from "./pages/Messages";
import MessagesNewPage from "./pages/MessagesNew";
import VehicleFirmwaresPage from "./pages/VehicleFirmware";
import ApiLogsPages from "./pages/Logs";
import TesterPage from "./pages/Tester";
import SwapsPage from "./pages/Swaps";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { path: "", element: <MainDashboard /> },

      // Per ogni entità, usa un solo componente che gestisce tutte le route
      { path: "batteries", element: <BatteriesPage /> },
      { path: "batteries/new", element: <BatteriesPage /> },
      { path: "batteries/:id", element: <BatteriesPage /> },
      { path: "batteries/:id/edit", element: <BatteriesPage /> },

      { path: "battery-firmwares", element: <BatteryFirmwaresPage /> },
      { path: "battery-firmwares/new", element: <BatteryFirmwaresPage /> },
      { path: "battery-firmwares/:id", element: <BatteryFirmwaresPage /> },
      { path: "battery-firmwares/:id/edit", element: <BatteryFirmwaresPage /> },

      { path: "battery-stations", element: <BatteryStationsPage /> },
      { path: "battery-stations/new", element: <BatteryStationsPage /> },
      { path: "battery-stations/:id", element: <BatteryStationsPage /> },
      { path: "battery-stations/:id/edit", element: <BatteryStationsPage /> },

      { path: "swaps", element: <SwapsPage /> },
      { path: "swaps/new", element: <SwapsPage /> },
      { path: "swaps/:id", element: <SwapsPage /> },
      { path: "swaps/:id/edit", element: <SwapsPage /> },

      { path: "battery-subscriptions", element: <BatterySubscriptionsPage /> },
      { path: "battery-subscriptions/new", element: <BatterySubscriptionsPage /> },
      { path: "battery-subscriptions/:id", element: <BatterySubscriptionsPage /> },
      { path: "battery-subscriptions/:id/edit", element: <BatterySubscriptionsPage /> },

      { path: "home-chargers", element: <HomeChargersPage /> },
      { path: "home-chargers/new", element: <HomeChargersPage /> },
      { path: "home-chargers/:id", element: <HomeChargersPage /> },
      { path: "home-chargers/:id/edit", element: <HomeChargersPage /> },

      { path: "home-charger-subscriptions", element: <HomeChargerSubscriptionsPage /> },
      { path: "home-charger-subscriptions/new", element: <HomeChargerSubscriptionsPage /> },
      { path: "home-charger-subscriptions/:id", element: <HomeChargerSubscriptionsPage /> },
      { path: "home-charger-subscriptions/:id/edit", element: <HomeChargerSubscriptionsPage /> },

      { path: "vehicles", element: <VehiclesPages /> },
      { path: "vehicles/new", element: <VehiclesPages /> },
      { path: "vehicles/:id", element: <VehiclesPages /> },
      { path: "vehicles/:id/edit", element: <VehiclesPages /> },

      { path: "vehicle-firmwares", element: <VehicleFirmwaresPage /> },
      { path: "vehicle-firmwares/new", element: <VehicleFirmwaresPage /> },
      { path: "vehicle-firmwares/:id", element: <VehicleFirmwaresPage /> },
      { path: "vehicle-firmwares/:id/edit", element: <VehicleFirmwaresPage /> },

      { path: "users", element: <UsersPage /> },
      { path: "users/new", element: <UsersPage /> },
      { path: "users/:id", element: <UsersPage /> },
      { path: "users/:id/edit", element: <UsersPage /> },

      { path: "app-users", element: <AppUsersPage /> },
      { path: "app-users/new", element: <AppUsersPage /> },
      { path: "app-users/:id", element: <AppUsersDetilePage /> },
      { path: "app-users/:id/edit", element: <AppUsersPage /> },

      { path: "messages", element: <MessagesPage /> },
      { path: "messages/new", element: <MessagesNewPage /> },

      { path: "tester", element: <TesterPage /> },

      { path: "groups", element: <GroupsPage /> },
      { path: "groups/new", element: <GroupsPage /> },
      { path: "groups/:id", element: <GroupsPage /> },
      { path: "groups/:id/edit", element: <GroupsPage /> },

      { path: "roles", element: <RolesPage /> },
      { path: "roles/new", element: <RolesPage /> },
      { path: "roles/:id", element: <RolesPage /> },
      { path: "roles/:id/edit", element: <RolesPage /> },

      { path: "logs", element: <ApiLogsPages /> },
      { path: "logs/new", element: <ApiLogsPages /> },
      { path: "logs/:id", element: <ApiLogsPages /> },
      { path: "logs/:id/edit", element: <ApiLogsPages /> },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);

export default router;
